import { hashHistory } from 'react-router';

// All paths
const PATHS = {
  MY_ON_DEMAND_ACCESS: 'my_on_demand_access',
  EXTEND: 'extend',
  OVERSTAY: 'overstay',
};

// Exported paths
export const MAIN_PATH = PATHS.MY_ON_DEMAND_ACCESS;
export const EXTEND_PATH = PATHS.EXTEND;
export const OVERSTAY_PATH = PATHS.OVERSTAY;

// Show
export const showOnDemandPath = (ref) => `/${MAIN_PATH}/${ref}`;
export const navigateToOnDemandShow = (ref) => {
  hashHistory.push(showOnDemandPath(ref));
};

// Extend
export const extendOnDemandPath = (ref) => `/${MAIN_PATH}/${ref}/${EXTEND_PATH}`;
export const navigateToExtendOndemand = (ref) => {
  hashHistory.push(extendOnDemandPath(ref));
};

// Overstay
export const overstayOnDemandPath = (ref) => `/${MAIN_PATH}/${ref}/${OVERSTAY_PATH}`;
export const navigateToOverstayOndemand = (ref) => {
  hashHistory.push(overstayOnDemandPath(ref));
};



// WEBPACK FOOTER //
// ./routes/my_on_demand_access/navigation.js